import { render, staticRenderFns } from "./ReviewReject.vue?vue&type=template&id=effb9656&scoped=true&"
import script from "./ReviewReject.vue?vue&type=script&lang=js&"
export * from "./ReviewReject.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReject.vue?vue&type=style&index=0&id=effb9656&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effb9656",
  null
  
)

export default component.exports